/**
 * File app.js.
 *
 * Theme Main Js File.
 *
 *
 */
import './customizer';
import './home-scripts';
import './floorplan-scripts';
import './gallery-scripts';
import './schedule-tour-scripts';
import './video-page-scripts';
import './vendor/fullpage/fullPageJs_min';

var previousState = 'out';

/*==== PAGE TRANSITIONS ====*/
jQuery(document).ready(function ($) {
  // No fade/delay here; .overlay_trans.transition is unused. Same-origin only.
  function getSameOriginHttpUrl(href) {
    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
    if (url.origin !== window.location.origin) {
      return null;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null;
    }
    return url;
  }

  function newpage(newLocation) {
    window.location.assign(newLocation);
  }

  $('a.trans_reg').click(function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    if (this.target && this.target !== '_self') {
      return;
    }
    var destination = getSameOriginHttpUrl(this.href);
    if (!destination) {
      return;
    }
    event.preventDefault();
    newpage(destination.href);
  });
});
/*==== END PAGE TRANSITIONS ====*/

/*====
    PRELOADER ANIMATIONS DgMgZxuXPyQS2Hw
====*/

jQuery(document).ready(function ($) {
  var def = $.Deferred();

  setTimeout(def.resolve, 6000);

  def.done(function () {
    $('.animation.home').fadeOut(3000);
  });

  /** Set Cookie */
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toGMTString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  /** Get Cookie */
  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  /** Check Cookie */
  function checkCookie() {
    var value = getCookie('modal');
    if (value != '') {
    } else {
      value = 'modal';
      if (value != '' && value != null) {
        setCookie('modal', value, 5);
      }
    }
  }
});

/*==== ANIMATE ANCHORS ====*/
jQuery(document).ready(function ($) {
  $('a.anchor').click(function () {
    $('html, body').animate(
      {
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset()
          .top,
      },
      1000
    );
    return false;
  });
});
/*==== END ANIMATE ANCHORS ====*/

/*=== ANIMATE ON SCROLL ====*/
jQuery(document).ready(function ($) {
  var doAnimations = function () {
    var offset = $(window).scrollTop() + $(window).height(),
      $animatables = $('.animatable');

    if ($animatables.length == 0) {
      $(window).off('scroll', doAnimations);
    }

    $animatables.each(function (i) {
      var $animatable = $(this);
      if ($animatable.offset().top + $(window).height() - 700 < offset) {
        $animatable.removeClass('animatable').addClass('animated');
      }
    });
  };

  $(window).on('scroll', doAnimations);
  $(window).trigger('scroll');
});
/*=== END ANIMATE ON SCROLL ====*/

function toggleHomeIntro() {
  $('.header_intro').toggleClass('header_intro--expanded');
  $('.header_intro--show').toggleClass('show--intro');
  $('#header_intro--cta img').toggleClass('rotate');
}

/*=== NAV ====*/

/************************************************************************************************************************* */
/*********************** Desktop menu but all with toggleClass for al fade class. ******************************************/
/************************************************************************************************************************* */
jQuery(document).ready(function ($) {
  $('.menu_icon_hover').click(function () {
    $(this).toggleClass('active');
    $('.resTag').toggleClass('fade');

    $('.floating-menu').toggleClass('removeMenu');
    $('.floating-menu__content').toggleClass('removeMenu');
    $('.floating-menu__title').toggleClass('floating-menu__title--off');

    $('.overlay_wrapper').toggleClass('active');
    $('.overlay_wrapper_home').toggleClass('active');

    $('.controls ul').addClass('initial');

    $('.outer ul li').removeClass('bump').removeClass('fixPos');
    $('#morning_icon').addClass('fixPos');
    $('#dusk_icon').addClass('fixPos');

    $('.column_wrapper *').toggleClass('fade');

    $('.child_main *').toggleClass('fade');

    $('.floorplan_wrapper').toggleClass('fade');

    $('.view_drawer').removeClass('active');

    if (previousState == 'fade' || $('.overlay_wrapper').hasClass('active')) {
      $('.gallery_holder').toggleClass('fade');
      $('.header_special').toggleClass('fade');
      if ($('.header_intro').hasClass('header_intro--expanded')) {
        toggleHomeIntro();
      } else {
        $('.header_contact').toggleClass('fade');
      }
    } else if (!$('.overlay_wrapper').hasClass('active')) {
      $('.gallery_holder').toggleClass('fade');
      if (
        !$('#floorplansMain').hasClass('active') &&
        !$('#mapMain').hasClass('active')
      ) {
        if ($('.header_intro').hasClass('header_intro--expanded')) {
          toggleHomeIntro();
        } else {
          $('.header_contact').toggleClass('fade');
        }
        $('.header_special').toggleClass('fade');
      }
    }
  });
});

/************************************************************************************************************************* */
/*********************** Mobile Menu but all with toggleClass for al fade class.  ******************************************/
/************************************************************************************************************************* */
jQuery(document).ready(function ($) {
  $('.menu_icon').click(function () {
    $(this).toggleClass('active');
    $('.resTag').toggleClass('fade');

    $('.overlay_wrapper').toggleClass('active');
    $('.overlay_wrapper_home').toggleClass('active');
    $('.home_cta').addClass('active');

    $('.controls ul').toggleClass('initial');

    $('.controls ul').removeClass('morning');
    $('.controls ul').removeClass('noon');
    $('.controls ul').removeClass('afternoon');
    $('.controls ul').removeClass('dusk');
    $('.controls ul').removeClass('evening');
    $('.controls ul').removeClass('night');

    $('.overlay_bg.morning').removeClass('active');
    $('.overlay_bg.noon').removeClass('active');
    $('.overlay_bg.afternoon').removeClass('active');
    $('.overlay_bg.dusk').removeClass('active');
    $('.overlay_bg.evening').removeClass('active');
    $('.overlay_bg.night').removeClass('active');

    $('.outer ul').removeClass('noon_icons');
    $('.outer ul').removeClass('afternoon_icons');
    $('.outer ul').removeClass('dusk_icons');
    $('.outer ul').removeClass('evening_icons');
    $('.outer ul').removeClass('night_icons');

    $('.column_wrapper *').toggleClass('fade');

    $('.child_main *').toggleClass('fade');

    $('.floorplan_wrapper').toggleClass('fade');

    $('.view_drawer').removeClass('active');

    // fade the bottom CTAs
    if (previousState == 'fade' || $('.overlay_wrapper').hasClass('active')) {
      $('.gallery_holder').toggleClass('fade');
      $('.header_contact').toggleClass('fade');
      if ($('.header_intro').hasClass('header_intro--expanded')) {
        toggleHomeIntro();
      }
      $('.header_special').toggleClass('fade');
    } else {
      $('.gallery_holder').toggleClass('fade');
      $('.header_contact').toggleClass('fade');
      if ($('.header_intro').hasClass('header_intro--expanded')) {
        toggleHomeIntro();
      }
      if (
        !$('#floorplansMain').hasClass('active') &&
        !$('#mapMain').hasClass('active')
      ) {
        $('.header_special').toggleClass('fade');
      }
    }
  });
});

jQuery(document).ready(function ($) {
  $('.home_cta').click(function () {
    $(this).toggleClass('active');

    $('.overlay_wrapper_home').toggleClass('active');
    $('.instructions').addClass('active');

    $('.controls ul').removeClass('initial');
  });
});
/*=== END NAV ====*/

/*==== FORM PLACEHOLDER ====*/

jQuery(document).ready(function ($) {
  $('input').focus(function () {
    $(this).data('placeholder', $(this).attr('placeholder'));
    $(this).attr('placeholder', '');
  });
  $('input').blur(function () {
    $(this).attr('placeholder', $(this).data('placeholder'));
  });
});

function checkIE() {
  var ieVr = -1;
  if (navigator.appName == 'Microsoft Internet Explorer') {
    var agent = navigator.userAgent;
    var exp = /MSIE/;
    // var exp = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (exp.match(agent)) {
      // (exp.exec(agent) != null)
      // console.log('MSIE');
      ieVr = 1; // parseFloat(RegExp.$1);
    }
  } else if (navigator.appName == 'Netscape') {
    // console.log('Here Netscape');
    var agent = navigator.userAgent;
    var exp = /Trident|Edge/;
    // console.log(agent);
    // var exp = new RegExp("Trident/.*ieVr:([0-9]{1,}[\.0-9]{0,})");
    // console.log(agent.match(exp));
    if (agent.match(exp)) {
      /*(exp.exec(agent) != null)*/
      ieVr = 1; // parseFloat(RegExp.$1);
      // console.log('Trident');
    }
  }
  return ieVr;
}

/*==== FIX touchscroll events ====*/
function isTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

function touchScroll(id) {
  if (isTouchDevice()) {
    //if touch events exist...
    var el = document.getElementById(id);
    var scrollStartPos = 0;

    document.getElementById(id).addEventListener(
      'touchstart',
      function (event) {
        scrollStartPos = this.scrollTop + event.touches[0].pageY;
        event.preventDefault();
      },
      false
    );

    document.getElementById(id).addEventListener(
      'touchmove',
      function (event) {
        this.scrollTop = scrollStartPos - event.touches[0].pageY;
        event.preventDefault();
      },
      false
    );
  }
}

var re = /\/about\//;
var uri = location.pathname;
if (uri.match(re)) {
  jQuery(document).ready(function ($) {
    var $window = $(window);
    var $body = $('body');
    var $caret = $('.conceptCaret');
    var $concept = $('.concept');
    var $overlay = $('.overlay_wrapper_home');
    var scrollDown = false,
      scrollUp = true,
      lastY;

    $caret.on('click', _scrollClick);
    $window.on('load', _windowLoad);
    $window.on('resize', _windowResize);

    function _windowLoad() {
      $body.css('overflow-y', 'hidden');
      $body.find('header').css('z-index', '555');

      _windowResize();
    }

    function _windowResize() {
      if ($body.width() >= 768 && $body.height() >= 606)
        $window.on('mousewheel DOMMouseScroll touchmove', _scrollDownEvent);
      else $window.off('mousewheel DOMMouseScroll touchmove', _scrollDownEvent);

      if ($body.width() < 768 || $body.height() < 606) {
        if (!$overlay.hasClass('scroll')) {
          $overlay.toggleClass('scroll');
          $concept.toggleClass('scroll');
        }
        $concept.find('.conceptCaretUp').css('display', 'none');
      } else {
        /*if($overlay.hasClass('scroll')) {
					$overlay.toggleClass('scroll');
					$concept.toggleClass('scroll');
				}*/
        $concept.find('.conceptCaretUp').css('display', 'block');
      }
    }

    function _scrollClick() {
      if (!$overlay.hasClass('scroll')) {
        $overlay.addClass('scroll');
        $concept.addClass('scroll');
      } else {
        $overlay.removeClass('scroll');
        $concept.removeClass('scroll');
      }
    }

    function _scrollDownEvent(event) {
      var currentY;

      if (
        event.type == 'mousewheel' &&
        event.originalEvent.wheelDelta < 0 &&
        !$concept.hasClass('scroll')
      ) {
        _scrollClick();
      } else if (
        event.type == 'DOMMouseScroll' &&
        event.originalEvent.detail > 0 &&
        !$concept.hasClass('scroll')
      ) {
        _scrollClick();
      } else if (
        event.type == 'touchmove' &&
        !$concept.hasClass('scroll') &&
        scrollUp
      ) {
        currentY = event.originalEvent.touches[0].clientY;
        if (currentY < lastY && !scrollDown) {
          scrollDown = true;
          scrollUp = false;
          _scrollClick();
          return;
        }
        lastY = currentY;
      }

      if (
        event.type == 'mousewheel' &&
        event.originalEvent.wheelDelta > 0 &&
        $concept.hasClass('scroll')
      ) {
        _scrollClick();
      } else if (
        event.type == 'DOMMouseScroll' &&
        event.originalEvent.detail < 0 &&
        $concept.hasClass('scroll')
      ) {
        _scrollClick();
      } else if (
        event.type == 'touchmove' &&
        $concept.hasClass('scroll') &&
        scrollDown
      ) {
        currentY = event.originalEvent.touches[0].clientY;
        if (currentY > lastY && !scrollUp) {
          scrollUp = true;
          scrollDown = false;
          _scrollClick();
        }
        lastY = currentY;
      }
    }
  });
}

function fullPageIt() {
  // console.log(checkIE());
  if (checkIE() == 1) {
    $('#fullpage').fullpage({
      autoScrolling: false,
      normalScrollElements: '#floorplansMain, #mapMain',
      fitToSection: true,
      scrollBar: true,
      easing: 'easeInOutCubic',
      touchSensitivity: 10,
      keyboardScrolling: true,
      animateAnchor: false,
      recordHistory: false,
      anchors: [],
      afterLoad: function (anchorLink, index) {
        let loadedSection = $(this);

        if (loadedSection.find('.fullpage__content--text figure')) {
          loadedSection.find('.fullpage__content--text figure').fadeIn('slow');
        }

        if (loadedSection.find('.fullpage__content--text h3')) {
          loadedSection.find('.fullpage__content--text h3').fadeIn('slow');
        }

        if (loadedSection.find('.fullpage__content--text p')) {
          loadedSection.find('.fullpage__content--text p').fadeIn('slow');
        }

        if (loadedSection.find('.arrow--next')) {
          loadedSection.find('.arrow--next').fadeIn('slow');
        }

        if (loadedSection.find('.arrow--up')) {
          loadedSection.find('.arrow--up').fadeIn('slow');
        }
      },
      onLeave: function (index, nextIndex, direction) {
        let onleaveSection = $(this);

        if (onleaveSection.find('.fullpage__content--text figure')) {
          onleaveSection
            .find('.fullpage__content--text figure')
            .fadeOut('slow');
        }

        if (onleaveSection.find('.fullpage__content--text h3')) {
          onleaveSection.find('.fullpage__content--text h3').fadeOut('slow');
        }

        if (onleaveSection.find('.fullpage__content--text p')) {
          onleaveSection.find('.fullpage__content--text p').fadeOut('slow');
        }

        if (onleaveSection.find('.arrow--next')) {
          onleaveSection.find('.arrow--next').fadeOut('slow');
        }

        if (onleaveSection.find('.arrow--up')) {
          onleaveSection.find('.arrow--up').fadeOut('slow');
        }

        if (direction == 'down') {
          var nextSection = $(this).next();
        } else {
          var nextSection = $(this).prev();
        }

        nextSection.find('.fullpage__content--text figure').fadeIn('slow');

        nextSection.find('.fullpage__content--text h3').fadeIn('slow');

        nextSection.find('.fullpage__content--text p').fadeIn('slow');

        nextSection.find('.arrow--next').fadeIn('slow');

        nextSection.find('.arrow--up').fadeIn('slow');
      },
    });
  } else {
    $('#fullpage').fullpage({
      autoScrolling: true,
      normalScrollElements: '#floorplansMain, #mapMain',
      fitToSection: true,
      scrollBar: true,
      easing: 'easeInOutCubic',
      touchSensitivity: 10,
      keyboardScrolling: true,
      animateAnchor: false,
      recordHistory: false,
      anchors: [],
      afterLoad: function (anchorLink, index) {
        let loadedSection = $(this);

        if (loadedSection.find('.fullpage__content--text figure')) {
          loadedSection.find('.fullpage__content--text figure').fadeIn('slow');
        }

        if (loadedSection.find('.fullpage__content--text h3')) {
          loadedSection.find('.fullpage__content--text h3').fadeIn('slow');
        }

        if (loadedSection.find('.fullpage__content--text p')) {
          loadedSection.find('.fullpage__content--text p').fadeIn('slow');
        }

        if (loadedSection.find('.arrow--next')) {
          loadedSection.find('.arrow--next').fadeIn('slow');
        }

        if (loadedSection.find('.arrow--up')) {
          loadedSection.find('.arrow--up').fadeIn('slow');
        }
      },
      onLeave: function (index, nextIndex, direction) {
        let onleaveSection = $(this);

        if (onleaveSection.find('.fullpage__content--text figure')) {
          onleaveSection
            .find('.fullpage__content--text figure')
            .fadeOut('slow');
        }

        if (onleaveSection.find('.fullpage__content--text h3')) {
          onleaveSection.find('.fullpage__content--text h3').fadeOut('slow');
        }

        if (onleaveSection.find('.fullpage__content--text p')) {
          onleaveSection.find('.fullpage__content--text p').fadeOut('slow');
        }

        if (onleaveSection.find('.arrow--next')) {
          onleaveSection.find('.arrow--next').fadeOut('slow');
        }

        if (onleaveSection.find('.arrow--up')) {
          onleaveSection.find('.arrow--up').fadeOut('slow');
        }

        if (direction == 'down') {
          var nextSection = $(this).next();
        } else {
          var nextSection = $(this).prev();
        }

        nextSection.find('.fullpage__content--text figure').fadeIn('slow');

        nextSection.find('.fullpage__content--text h3').fadeIn('slow');

        nextSection.find('.fullpage__content--text p').fadeIn('slow');

        nextSection.find('.arrow--next').fadeIn('slow');

        nextSection.find('.arrow--up').fadeIn('slow');
      },
    });
  }
}

(function ($) {
  let $fullPageSections = $('#fullpage');

  if (
    $('body').hasClass('page-amenities') ||
    $('body').hasClass('page-features')
  ) {
    $fullPageSections.children().each(function (index, value) {
      if (index == $fullPageSections.children().length - 1) {
        $(this).addClass('last--fullpage--section');
        $(this).find('.arrow--container--up').addClass('arrow--up');
      } else {
        $(this).addClass('fullpage--section');
        $(this).find('.arrow--container--next').addClass('arrow--next');
      }
    });
  }

  if ($('body').hasClass('page-amenities')) {
    fullPageIt();
  }

  if ($('body').hasClass('page-features')) {
    fullPageIt();
  }

  $('.arrow--next__img').on('click', function (e) {
    let $this = $(e.target);
    $.fn.fullpage.moveSectionDown();
  });

  $('.arrow--up__img').on('click', function (e) {
    let $this = $(e.target);
    $.fn.fullpage.moveSectionUp();
  });
})(jQuery);
